export default "__VITE_ASSET__B$Nxm5Gk__"